import { Button, Checkbox, Dropdown, Flex, Tooltip } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTableContext } from './TableProvider'
import { GridIcon } from 'src/assets/icons'
import { defaultActionColId, emptyArrayLength } from '../table.constants'
import { IOption, TableColumnDefs } from '../table.model'

const TableDropdown: React.FC = () => {
  const { t } = useTranslation()
  const {
    defs,
    chosenColumns = [],
    isUpdatingSetting,
    dropdownOpen,
    displayColumnBtn = true,
    disableTableControl = false,
    setChosenColumn,
    onCancel,
    onApplyColumn,
    onToggleDropdown,
  } = useTableContext()

  const columnOptions: Array<IOption> = useMemo(() => {
    return (
      defs
        ?.filter((item) => ![defaultActionColId].includes(item?.colId) && !item?.rowGroup)
        .map((item: TableColumnDefs) => ({
          label: item?.headerName,
          value: item?.colId,
        })) ?? []
    )
  }, [defs])

  const renderColumnDropdown = useCallback(
    () => (
      <div className='column-dropdown-container'>
        <div className='column-checkbox-section'>
          <Checkbox.Group options={columnOptions} value={chosenColumns} onChange={setChosenColumn} />
        </div>
        <Flex justify='flex-end' gap={8}>
          <Button onClick={onCancel} disabled={isUpdatingSetting} style={{ fontWeight: 600 }}>
            {t('common:cancel')}
          </Button>
          <Button
            type='primary'
            onClick={onApplyColumn}
            loading={isUpdatingSetting}
            disabled={isUpdatingSetting || chosenColumns.length === emptyArrayLength}
          >
            {t('common:apply')}
          </Button>
        </Flex>
      </div>
    ),
    [chosenColumns, columnOptions, isUpdatingSetting, onCancel, onApplyColumn, setChosenColumn, t],
  )

  if (!displayColumnBtn || disableTableControl) {
    return <React.Fragment />
  }

  return (
    <Dropdown
      trigger={['click']}
      placement='bottomRight'
      open={dropdownOpen}
      dropdownRender={renderColumnDropdown}
      onOpenChange={onToggleDropdown}
    >
      <Tooltip placement='top' title={t('OverallFunctionality:table.search.column_button_title')}>
        <Button id='column-button' icon={<GridIcon />} onClick={onToggleDropdown} disabled={isUpdatingSetting} />
      </Tooltip>
    </Dropdown>
  )
}

export default TableDropdown
